const SERVICES_FILTER_ABORT_KEY = "__servicesFilterAbortController"

export const ServicesFilter = () => {
  const filterSelector = document.querySelector(".service-category-filter") as HTMLSelectElement | null
  if (!filterSelector) return

  const host = filterSelector as HTMLElement & { [SERVICES_FILTER_ABORT_KEY]?: AbortController }
  host[SERVICES_FILTER_ABORT_KEY]?.abort()

  const abortController = new AbortController()
  host[SERVICES_FILTER_ABORT_KEY] = abortController

  filterSelector.addEventListener(
    "change",
    event => {
      const allServicesTiles = document.querySelectorAll(".web-services-container .web-service-card.explore-tile")
      const option = (event.target as HTMLSelectElement).selectedOptions[0]
      const optGroup = option.parentElement

      const value = (event.target as HTMLSelectElement).value

      if (optGroup?.label === "Filters") {
        if (value === "All") {
          allServicesTiles.forEach(tile => tile.classList.remove("hide"))
        } else {
          const tag = value.toLowerCase()
          allServicesTiles.forEach(tile => {
            if ((tile as HTMLElement).dataset.tags === tag) {
              tile.classList.remove("hide")
            } else {
              tile.classList.add("hide")
            }
          })
        }
      } else if (optGroup?.label === "Categories") {
        allServicesTiles.forEach(tile => {
          if ((tile as HTMLElement).dataset.category == value) {
            tile.classList.remove("hide")
          } else {
            tile.classList.add("hide")
          }
        })
      }

      const filterQueryParam = value.toLowerCase().split(/\W+/).join("-")
      let url = filterSelector.dataset.serviceBaseUrl
      if (filterQueryParam !== "all" && url) {
        url += `/${filterQueryParam}`
      }
      if (url) {
        window.history["replaceState"]({ url }, "", url)
      }
    },
    { signal: abortController.signal }
  )
}
